export const serviceInterfaces = Object.freeze([
  { text: 'SOAP', value: '0' },
  { text: 'REST', value: '3' },
  { text: 'RestAsync', value: '4' },
  { text: 'RestSaxo', value: '5' },
]);

export default {};
